<template>
  <div class="calendar-view-selector" :class="isMobile && 'row'">
    <div
      v-for="(item, index) in viewModes"
      :key="'calendarViewSelector' + index"
      class="col-3"
      :class="[{ active: item.id == value, 'mx-0': isMobile }]"
      @click="Value(item)"
    >
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import calendarViewModes from '@/utils/shared/constants/calendarViewModes';

export default {
  name: 'VisitCalendarViewModeSelector',
  props: {
    value: {
      type: Number,
      default: () => calendarViewModes.Week,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    viewModes() {
      return [
        { id: calendarViewModes.Week, name: 'Semana' },
        { id: calendarViewModes.Day, name: 'Día' },
      ];
    },
  },
  methods: {
    Value(item) {
      this.$emit('value-day-week', item.id);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.calendar-view-selector {
  display: flex;
  font-weight: bold;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    background-color: map-get($colors, 'gray-1');
    margin-right: 8px;
    cursor: pointer;
    border-radius: 4px;
    span {
      user-select: none;
    }

    &.active {
      background: map-get($colors, 'orange');
      color: map-get($colors, 'white');
    }
  }
}
</style>
